import CommunicationConst from "../communication-const";
import type {
  TCommunicationTask,
  TCommunicationVisibleTab,
} from "./communication-types-helper";

export const getCommunicationOpenActionLabelKey = (
  task: TCommunicationTask,
  currentVisibleTab: TCommunicationVisibleTab
): string => {
  if (
    currentVisibleTab === "audit"
    || task.status === CommunicationConst.statuses.APPROVED
    || task.status === CommunicationConst.statuses.DISMISSED
  ) {
    return "COMMUNICATION.Button_View";
  }

  if (task.status === CommunicationConst.statuses.UNIDENTIFIED) {
    return "COMMUNICATION.Button_StartMatch";
  }

  return "COMMUNICATION.Button_StartReview";
};
